export default __webpack_public_path__ + "static/media/banner-offer.4b46705c.jpg";